import { newObjectId } from './Utils'

export interface User {
    id: number
    userName: string
    firstName: string
    lastName: string
    email: string
    active: boolean
    individualRights: Record<number, boolean>
    projectRights: Record<number, ProjectRight>
}

export function createNewUser(): User {
    return {
        id: newObjectId,
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        active: true,
        individualRights: {},
        projectRights: {}
    }
}

export class ProjectRight {
    languageRights: Record<number, boolean> = {}
    individualRights: Record<number, boolean> = {}
}

export enum UserIndividualRights {
    FullAdministrative,
    User,
    Projects,
    Languages

}

export enum ProjectIndividualRights {
    EditDeleteKeys,
    CreateFiles,
    UploadFiles
}